import React, {ReactElement, useState} from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  ShareIcon
} from '@customink/pigment-react';
import services from '../../api/remoteServices';
import CopyLinkTextButton from '../CopyLinkTextButton';

type ShareLinkDialogProps = {
  storeSlug: string;
  mobile: boolean;
};

const ShareLinkDialog: React.FC<ShareLinkDialogProps> = ({
  storeSlug,
  mobile
}: ShareLinkDialogProps): ReactElement => {
  const storeUrl = `${services.storefront}/${storeSlug}`;

  const [open, setOpen] = useState(false);
  const handleClick = () => {
    setOpen(!open);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div className="shareLinkDialog">
      <Button
        className={`share${mobile ? '-mobile' : ''}`}
        aria-label="shareLink"
        variant="secondary"
        size="small"
        onClick={handleClick}
        endIcon={<ShareIcon />}>
        Share
      </Button>
      <Dialog
        width="md"
        title="Share Page"
        open={open}
        padding={{
          paddingTop: '1.25rem',
          paddingRight: '1rem',
          paddingBottom: '2rem',
          paddingLeft: '1rem'
        }}
        titleSx={{height: '2rem'}}
        onClose={handleClose}>
        <DialogContent
          sx={{
            wordBreak: 'break-word',
            display: 'flex',
            justifyContent: 'space-between',
            flexDirection: 'column',
            gap: '1.5rem',
            fontSize: '1rem',
            lineHeight: '1.75rem'
          }}>
          <Typography className="content" variant="bodyShort2" gutterBottom>
            Use this link to share with other people who might be interested.
          </Typography>
          <Typography
            variant="bodyShort2"
            weight="bold"
            textAlign="center"
            gutterBottom>
            {storeUrl}
          </Typography>
        </DialogContent>
        <DialogActions className="shareLinkDialog-actions">
          <CopyLinkTextButton
            copyLink={storeUrl}
            size="large"
            variant="secondary"
            fullWidth
            resetTime={2000}
          />
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ShareLinkDialog;
